import { Box, Text } from '@chakra-ui/react';

export const ProgressPreview = () => {
  return (
    <Box>
      <Text>ProgressPreview - Coming soon</Text>
    </Box>
  );
};
